import React, { useEffect } from "react";
import {
  Container,
  Box,
  Grid,
  Paper,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  Avatar,
  withStyles,
  TableCell,
} from "@material-ui/core";
import BodyText from "./BodyText";
import DashboardTable from "./DashboardTable";
import DashboardTable2 from "./DashboardTable2";
import { useDispatch, useSelector } from "react-redux";
import TitleText from "./TitleText";
import { agenttransactionhistoryDispatch } from "../../reducers/UserReducer";
const tableHeaders = [
  "ID",
  "TYPE",
  "CART_ID",
  "DOJ",
  "COMMISSION",
  "MARKUP",
  "AMOUNT",
  "AVAL_BAL",
  "PAY_TYPE",
  "DATE",
  "HOLD_S",
  "TRANS_S",
  "DESC",
];

const StyledTableCell = withStyles((theme) => ({
  head: {
    fontWeight: 600,

    // padding: 3,
    fontSize: 14,
    textTransform: "uppercase",
    background: "aliceblue",
  },
  root: {
    borderBottom: "none",
    paddingBottom: 0,
  },
}))(TableCell);
const TransactionHistory = () => {
  const { transagent, agentlogin } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  useEffect(() => {
   
    dispatch(agenttransactionhistoryDispatch(agentlogin && agentlogin.result.result.id));
  }, []);
  return (
    <>
      <Grid container spacing={2}>
        <Box>
          <h2 style={{ fontFamily: "Josefin Sans, sans-serif" }}>
            Transaction History
          </h2>
        </Box>
        <Grid item xs={12}>
          <TableContainer style={{ marginTop: 15 }}>
            <Table>
              <TableHead>
                <TableRow>
                  {tableHeaders.map((title, index) => (
                    <StyledTableCell key={title}>{title}</StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {transagent &&
                  transagent.result &&
                  transagent.result.result?.length > 0 &&
                  transagent.result.result?.map((item, index) => {
                    return <DashboardTable2 rowIndex={index} item={item} />;
                  })}
                {/* {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i, index) => {
									return
								})} */}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </>
  );
};

export default TransactionHistory;
